class Subscription {
  constructor(data) {
    this.expiresOn = data.expiresOn
    this.expiredAt = data.expiredAt
    this.renewingOn = data.renewingOn
    this.endedAt = data.endedAt
    this.endingOn = data.endingOn
    this.createdAt = data.createdAt
    this.productAccessProviderName = data.productAccessProviderName
    this.productName = data.productName
    this.publicId = data.publicId
    this.applicationName = data.applicationName
    this.preCanceled = data.preCanceled
    this.canBeCanceled = data.canBeCanceled
    this.isOrgSubscription = data.isOrgSubscription
    this.isTrial = data.isTrial
    this.isGift = data.isGift
    this.canToggleRenewing = data.canToggleRenewing
    this.autoRenewEnabled = data.autoRenewEnabled

    this.isInGrace = data.isInGrace;
    this.isInRetry = data.isInRetry;
    this.updatePaymenMethodUrl = data.updatePaymenMethodUrl;
  }
}
export default Subscription
